@for (column of columns(); track $index) {
  <td
    class="px-4 py-2.5 transition-colors border-b border-base-200 truncate"
    [class.bg-primary/5]="selected() || active() || open()"
    (contextmenu)="open.set(true)"
    (clickOutside)="open.set(false)"
    [cdkContextMenuTriggerFor]="context"
    gridCell
    [(selecteds)]="selecteds"
    [class.cursor-pointer]="column.cellClickHandler"
    [column]="column"
    [row]="row()"></td>
}

<ng-template #context>
  @if (rowOptions(); as options) {
    @if (options.length > 0) {
      <lepi-menu cdkMenu>
        @for (option of options; track option) {
          <lepi-menu-option [icon]="option.icon" (click)="handleOption(option)" cdkMenuItem>{{
            option.label
          }}</lepi-menu-option>
        }
      </lepi-menu>
    }
  }
</ng-template>
